import {
  Editor,
  Path,
  Transforms
} from 'slate';
import {
  ReactEditor
} from 'slate-react';

import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import { toggleBlock } from '../../3rd-party/rich-text';
import HelptapEditor from '../';

export function getDefaultOptions(overrides) {

  return basicEditorValueSerializer.utilities.node.file.getDefaultOptions(overrides);

}

export function buildNode(options) {

  return basicEditorValueSerializer.utilities.node.file.buildNode(options);

}

export function buildImageNodeWithURL(url) {

  return basicEditorValueSerializer.utilities.node.file.buildImageNodeWithURL(url);

}

export function buildVideoNodeWithURL(url) {

  return basicEditorValueSerializer.utilities.node.file.buildVideoNodeWithURL(url);

}

export function buildAudioNodeWithURL(url) {

  return basicEditorValueSerializer.utilities.node.file.buildAudioNodeWithURL(url);

}

export function insert(editor, options, editorOptions, path) {

  Editor.withoutNormalizing(editor, () => {

    const node = buildNode(options);

    HelptapEditor.insertNode(editor, node);

  });

}

export function insertMany(editor, files, editorOptions, path) {

  Editor.withoutNormalizing(editor, () => {

    for (let file of files) {
      const node = buildNode({ rawFile: file });

      HelptapEditor.insertNode(editor, node);
    }

  });

}

export function toggle(editor, options, editorOptions, path) {

  Editor.withoutNormalizing(editor, () => {

    const node = buildNode(options);

    toggleBlock(editor, node.type, node);

  });

}

export function cloneNode(node) {

  const file = node.attributes.file;

  if (file === void 0 || typeof file !== 'object' || file === null) {
    throw Error('Cannot duplicate this node');
  }

  if (typeof file._id !== 'string') {
    return { ...node };
  }

  const clonedNode = {
    ...node,
    attributes: {
      ...node.attributes,
      file: null,
      rawFile: null
    },
    properties: {
      ...(node.properties || {}),
      cloneFrom: file._id
    }
  };

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(HelptapEditor.cloneNode(node));

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

function getRangeFromPoint(x, y) {
  let range = null;

  if (document.caretPositionFromPoint) {
    const caretPosition = document.caretPositionFromPoint(x, y);
    range = document.createRange();
    range.setStart(caretPosition.offsetNode, caretPosition.offset);
    range.setEnd(caretPosition.offsetNode, caretPosition.offset); // For a collapsed range
  } else if (document.caretRangeFromPoint) {
    range = document.caretRangeFromPoint(x, y);
  }

  return range;
}

function tryDetermineDropPathFromSelection(editor) {
  if (!editor.selection) {
    return [0];
  } else {
    return editor.selection.focus.path;
  }
}

function getSlatePointFromDOMRange(editor, domRange) {

  const slatePoint = ReactEditor.toSlateRange(editor, domRange, {});

  return slatePoint;
}

function determineDropPath(editor, event) {

  const { clientX, clientY } = event;

  const domRange = getRangeFromPoint(clientX, clientY);

  if (!domRange) {
    return tryDetermineDropPathFromSelection(editor);
  }

  const slatePoint = getSlatePointFromDOMRange(editor, domRange);

  if (!slatePoint) {
    return tryDetermineDropPathFromSelection(editor);
  }

  return slatePoint;

}

export function handleDrop(editor, event, destination = [0]) {

  event.stopPropagation();

  let dropPath = determineDropPath(editor, event);

  Transforms.select(editor, dropPath);

  const fragment = [];
  if (event.dataTransfer.items) {
    // Use DataTransferItemList interface to access the file(s)
    for (let i = 0; i < event.dataTransfer.items.length; i++) {
      // If dropped items aren't files, reject them
      if (event.dataTransfer.items[i].kind === 'file') {
        const file = event.dataTransfer.items[i].getAsFile();
        const node = buildNode({
          rawFile: file
        });

        fragment.push(node);
      }
    }
  } else {
    // Use DataTransfer interface to access the file(s)
    for (let i = 0; i < event.dataTransfer.files.length; i++) {
      const file = event.dataTransfer.files[i];
      const node = buildNode({
        rawFile: file
      });

      fragment.push(node);
    }
  }

  HelptapEditor.copyPaste.insertFragment(editor, fragment);

}